import React from 'react';
import Icon from 'components/AppIcon';
import Button from 'components/ui/Button';

const territories = ['All Territories', 'NCR', 'Luzon North', 'Luzon South', 'Visayas', 'Mindanao', 'Cebu', 'Davao'];
const categories = ['All Categories', 'Premium Rice', 'Cooking Oil', 'Canned Goods', 'Beverages', 'Snacks'];
const teams = ['All Teams', 'National', 'Regional', 'Area', 'Territory'];

export default function FilterBar({ filters, setFilters, onExport }) {
  const handleChange = (key, value) => setFilters(prev => ({ ...prev, [key]: value }));

  return (
    <div className="card p-3 lg:p-4">
      <div className="flex flex-col sm:flex-row items-start sm:items-center gap-3 flex-wrap">
        <div className="flex items-center gap-2 flex-shrink-0">
          <Icon name="Filter" size={15} color="var(--color-primary)" strokeWidth={2} />
          <span className="font-caption text-sm font-semibold text-foreground">Filters:</span>
        </div>
        <div className="flex flex-wrap gap-2 flex-1">
          {[
            { key: 'territory', options: territories, label: 'Territory' },
            { key: 'category', options: categories, label: 'Category' },
            { key: 'team', options: teams, label: 'Team Level' },
          ]?.map(({ key, options, label }) => (
            <select
              key={key}
              value={filters?.[key]}
              onChange={(e) => handleChange(key, e?.target?.value)}
              className="px-3 py-1.5 bg-muted border border-border rounded-md font-caption text-sm text-foreground focus:outline-none focus:ring-2 focus:ring-ring min-h-[36px]"
              aria-label={label}
            >
              {options?.map((o) => <option key={o} value={o}>{o}</option>)}
            </select>
          ))}
        </div>
        <div className="flex items-center gap-2 flex-shrink-0">
          <Button variant="outline" size="sm" iconName="FileText" iconPosition="left" iconSize={14} onClick={() => onExport('pdf')}>PDF</Button>
          <Button variant="outline" size="sm" iconName="Table" iconPosition="left" iconSize={14} onClick={() => onExport('excel')}>Excel</Button>
          <Button variant="outline" size="sm" iconName="Download" iconPosition="left" iconSize={14} onClick={() => onExport('csv')}>CSV</Button>
        </div>
      </div>
    </div>
  );
}